(() => {
  const root = document.querySelector('[data-emu-pickup-video]');
  if (!root) return;

  const main = document.querySelector('#MainContent');
  const featuredCollection = main?.querySelector('[id$="__featured_collection"]');

  if (main && featuredCollection) {
    main.insertBefore(root, featuredCollection);
  }

  root.hidden = false;

  const modal = root.querySelector('[data-emu-pickup-video-modal]');
  const modalFrame = root.querySelector('[data-emu-pickup-video-modal-frame]');
  const closeButton = root.querySelector('[data-emu-pickup-video-close]');
  const cards = root.querySelectorAll('[data-emu-pickup-video-card]');

  const buildEmbedUrl = (videoId, { autoplay = true, muted = false, controls = true } = {}) => {
    const params = new URLSearchParams({
      autoplay: autoplay ? '1' : '0',
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
      loop: '1',
      playlist: videoId,
      controls: controls ? '1' : '0',
    });

    if (muted) params.set('mute', '1');

    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
  };

  const createIframe = (videoId, options) => {
    const iframe = document.createElement('iframe');
    iframe.src = buildEmbedUrl(videoId, options);
    iframe.title = 'YouTube Shorts';
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    return iframe;
  };

  const startPreview = (card) => {
    if (card.querySelector('.emu-pickup-video__preview')) return;

    const videoId = card.dataset.videoId;
    const media = card.querySelector('.emu-pickup-video__media');
    const iframe = createIframe(videoId, { autoplay: true, muted: true, controls: false });
    iframe.className = 'emu-pickup-video__preview';
    media.appendChild(iframe);
    card.classList.add('is-previewing');
  };

  const stopPreview = (card) => {
    card.querySelector('.emu-pickup-video__preview')?.remove();
    card.classList.remove('is-previewing');
  };

  const openModal = async (videoId) => {
    modalFrame.replaceChildren(createIframe(videoId, { autoplay: true, muted: false, controls: true }));
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('emu-pickup-video-open');
    closeButton.focus({ preventScroll: true });

    try {
      await modal.requestFullscreen();
    } catch (_error) {
      // Fullscreen can be blocked by the browser; the fixed overlay remains usable.
    }
  };

  const closeModal = async () => {
    modalFrame.replaceChildren();
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('emu-pickup-video-open');

    if (document.fullscreenElement) {
      try {
        await document.exitFullscreen();
      } catch (_error) {
        // Ignore native fullscreen exit failures.
      }
    }
  };

  cards.forEach((card) => {
    card.addEventListener('mouseenter', () => startPreview(card));
    card.addEventListener('mouseleave', () => stopPreview(card));
    card.addEventListener('focus', () => startPreview(card));
    card.addEventListener('blur', () => stopPreview(card));
    card.addEventListener('click', () => openModal(card.dataset.videoId));
  });

  closeButton.addEventListener('click', closeModal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
